import React, { useState, useContext } from 'react';
import axios from 'axios';
import { DBContext } from './DBContext';

const CheckTables = () => {
    const { logginedDB } = useContext(DBContext);
    const apiBaseUrl = process.env.REACT_APP_API_BASE_URL ;
    
    const [status, setStatus] = useState("Idle");
    const [result, setResult] = useState(null);
    const [loading, setLoading] = useState(false);

    const runMigration = async () => {
        if (!logginedDB) {
            setStatus("Error: No database selected.");
            return;
        }

        setLoading(true);
        setStatus(`Running migration script on ${logginedDB}. Please wait...`);
        setResult(null);
        
        try {
            const response = await axios.post(`${apiBaseUrl}/api/run-migration/${logginedDB}`, {}, {
                headers: {
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            });
            setStatus(response.data.message || "Success!");
            setResult(response.data);
        } catch (error) {
            setStatus("Error executing migration.");
            setResult(error.response ? error.response.data : { error: error.message });
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="w-full bg-[#f8f9fa] border-b border-gray-200 p-4 mb-4 flex flex-col rounded shadow-sm">
            <div className="flex items-center justify-between">
                <div>
                    <h3 className="text-lg font-semibold text-gray-800">Database Tools: Check & Sync Tables (Temporary)</h3>
                    <p className="text-sm text-gray-600">Target Database: <strong>{logginedDB || "None"}</strong></p>
                </div>
                <button 
                    onClick={runMigration} 
                    disabled={loading || !logginedDB}
                    className={`px-4 py-2 font-medium rounded text-white ${loading || !logginedDB ? 'bg-gray-400 cursor-not-allowed' : 'bg-red-600 hover:bg-red-700'}`}
                >
                    {loading ? "Processing..." : "Run Migration & Sync"}
                </button>
            </div>
            
            <div className="mt-2 text-sm">
                <strong>Status: </strong> 
                <span className={status.includes('Error') ? 'text-red-600' : 'text-green-600'}>{status}</span>
            </div>
            
            {result && (
                <div className="mt-3 bg-gray text-green-400 p-3 rounded overflow-x-auto max-h-64 customScroll text-xs font-mono">
                    <pre>{JSON.stringify(result, null, 2)}</pre>
                </div>
            )}
        </div>
    );
};

export default CheckTables;
